import AddIcon from "./AddIcon";
import AlertIcon from "./AlertIcon";
import ApplyIcon from "./ApplyIcon";
import ArchiveIcon from "./ArchiveIcon";
import ArrowDownIcon from "./ArrowDownIcon";
import ArrowDropDownIcon from "./ArrowDropDownIcon";
import ArrowDropRightIcon from "./ArrowDropRightIcon";
import ArrowDropUpIcon from "./ArrowDropUpIcon";
import ArrowLeftIcon from "./ArrowLeftIcon";
import ArrowRightIcon from "./ArrowRightIcon";
import ArrowUpIcon from "./ArrowUpIcon";
import AssignIcon from "./AssignIcon";
import BadgeDotIcon from "./BadgeDotIcon";
import BarChartIcon from "./BarChartIcon";
import BrandIcon from "./BrandIcon";
import CalendarIcon from "./CalendarIcon";
import CancelIcon from "./CancelIcon";
import CheckCircleIcon from "./CheckCircleIcon";
import CheckIcon from "./CheckIcon";
import ChevronDownIcon from "./ChevronDownIcon";
import ChevronLeftIcon from "./ChevronLeftIcon";
import ChevronRightIcon from "./ChevronRightIcon";
import ChevronUpIcon from "./ChevronUpIcon";
import ClientsIcon from "./ClientsIcon";
import CloseSmallIcon from "./CloseSmallIcon";
import ContractIocn from "./ContractIocn";
import CopyIcon from "./CopyIcon";
import CrossIcon from "./CrossIcon";
import CurrencyIcon from "./CurrencyIcon";
import DashboardIcon from "./DashboardIcon";
import DeleteIcon from "./DeleteIcon";
import DividerIcon from "./DividerIcon";
import DomainAddIcon from "./DomainAddIcon";
import DomainIcon from "./DomainIcon";
import EditSquareIcon from "./EditSquareIcon";
import EllipseIcon from "./EllipseIcon";
import EllipsisIcon from "./EllipsisIcon";
import EuroIcon from "./EuroIcon";
import FilterIcon from "./FilterIcon";
import FlagIcon from "./FlagIcon";
import HomeIcon from "./HomeIcon";
import styles from "./Icons.module.scss";
import InfoIcon from "./InfoIcon";
import LinkIcon from "./LinkIcon";
import ListIcon from "./ListIcon";
import LocationOnIcon from "./LocationOnIcon";
import ManageUserIcon from "./ManageUserIcon";
import NotificationIcon from "./NotificationIcon";
import OfficeIcon from "./OfficeIcon";
import { OnlineResultsLogoSmall } from "./OnlineResultsLogo";
import PersonIcon from "./PersonIcon";
import PieChartIcon from "./PieChartIcon";
import ProgressCircleButtonIcon from "./ProgressCircleButtonIcon";
import ProgressCircleIcon from "./ProgressCircleIcon";
import ProgressCircleWhiteButtonIcon from "./ProgressCircleWhiteButtonIcon";
import ReceiptIcon from "./ReceiptIcon";
import RemoveIcon from "./RemoveIcon";
import RocketIcon from "./RocketIcon";
import RocketLaunchIcon from "./RocketLaunchIcon";
import SavingsIcon from "./SavingsIcon";
import ScheduleIcon from "./ScheduleIcon";
import SchoolIcon from "./SchoolIcon";
import SearchIcon from "./SearchIcon";
import SellIcon from "./SellIcon";
import SettingsIcon from "./SettingsIcon";
import SignOutIcon from "./SignOutIcon";
import StoreIcon from "./StoreIcon";
import SyncIcon from "./SyncIcon";
import TagIcon from "./TagIcon";
import UniversalCurrentIcon from "./UniversalCurrentIcon";
import UserIcon from "./UserIcon";
import UserSearchIcon from "./UserSearchIcon";
import VisibilityIcon from "./VisibilityIcon";
import VisibilityOffIcon from "./VisibilityOffIcon";
import WalletIcon from "./WalletIcon";
import WarningIcon from "./WarningIcon";
import WorkIcon from "./WorkIcon";

const Icons = {
  BarChartIcon,
  HomeIcon,
  ListIcon,
  OfficeIcon,
  PieChartIcon,
  AddIcon,
  AlertIcon,
  ApplyIcon,
  ArchiveIcon,
  ArrowDownIcon,
  ArrowDropDownIcon,
  ArrowDropRightIcon,
  ArrowDropUpIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  AssignIcon,
  BadgeDotIcon,
  BrandIcon,
  CalendarIcon,
  CancelIcon,
  CheckCircleIcon,
  CheckIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronUpIcon,
  ClientsIcon,
  CloseSmallIcon,
  ContractIocn,
  CopyIcon,
  CrossIcon,
  CurrencyIcon,
  DashboardIcon,
  DeleteIcon,
  DividerIcon,
  DomainAddIcon,
  DomainIcon,
  EditSquareIcon,
  EllipseIcon,
  EllipsisIcon,
  EuroIcon,
  FilterIcon,
  FlagIcon,
  IconsModuleStyles: styles,
  InfoIcon,
  LinkIcon,
  LocationOnIcon,
  ManageUserIcon,
  NotificationIcon,
  PersonIcon,
  ProgressCircleButtonIcon,
  ProgressCircleIcon,
  ProgressCircleWhiteButtonIcon,
  ReceiptIcon,
  RemoveIcon,
  RocketIcon,
  RocketLaunchIcon,
  SavingsIcon,
  ScheduleIcon,
  SchoolIcon,
  SearchIcon,
  SellIcon,
  SettingsIcon,
  SignOutIcon,
  StoreIcon,
  SyncIcon,
  TagIcon,
  UniversalCurrentIcon,
  UserIcon,
  VisibilityIcon,
  VisibilityOffIcon,
  WalletIcon,
  WarningIcon,
  WorkIcon,
  UserSearchIcon,
  OnlineResultsLogoSmall,
};

export default Icons;
